// import './App.css';
// import { BrowserRouter } from 'react-router-dom';
// import store from './Store'; // redux
// import { Provider } from 'react-redux'; // redux
// import Sidebar from './components/Sidebar/Sidebar';
// import { Box } from '@mui/material';

// let authToken = localStorage.getItem('authToken');

// function App(props) {
//   return (
//     <Provider store={store}>
//       <BrowserRouter>
//         <Box sx={{ display: 'flex' }}>
//           <Sidebar />
//           <Box component="main" sx={{ flexGrow: 1}}>
//             <props.Component />
//           </Box>
//         </Box>
//       </BrowserRouter>
//     </Provider>
//   );
// }

// export default App;

// import React, { useEffect } from 'react';
// import './App.css';
// import { BrowserRouter } from 'react-router-dom';
// import { ToastContainer } from "react-toastify";
// // import store from './Store'; // redux
// import { Provider } from 'react-redux'; // redux
// import Layout from './components/Sidebar/Layout';
// import { Store } from './store/store';

// function App(props) {
//   return (
//     <Provider store={Store}>
//       <BrowserRouter>
//       <ToastContainer />
//         <Layout>
//           <props.Component />
//         </Layout>
//       </BrowserRouter>
//     </Provider>
//   );
// }

// export default App;

// App.js
import React, { useEffect } from "react";
import "./App.css";
import { BrowserRouter } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import { Provider } from "react-redux";
import { Store } from "./store/store";
import MyRoutes from "./router/Routes";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";

// 🔥 Firebase
import { initAnalytics } from "./firebase";

function App() {
  useEffect(() => {
    initAnalytics();
  }, []);

  return (
    <Provider store={Store}>
      <BrowserRouter>
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <ToastContainer />
          <MyRoutes />
        </LocalizationProvider>
      </BrowserRouter>
    </Provider>
  );
}

export default App;


